import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, CtnEmpty, CtnError, CtnHeader, downloadCtn, errorText, useCtnMetadata } from "@/components/ctn/shared";
import { emptyFilters } from "@/components/ctn/CtnFilters";
import { CtnReportToolbar, CtnReportExtraFilters } from "@/components/ctn/reports/CtnReportToolbar";
import { CtnReportStats } from "@/components/ctn/reports/CtnReportStats";
import { CtnSupplierChart } from "@/components/ctn/reports/CtnSupplierChart";
import { CtnDistributionChart } from "@/components/ctn/reports/CtnDistributionChart";
import { CtnReportLegend, CtnReportSection } from "@/components/ctn/reports/CtnReportChartParts";
import "@/components/ctn/ctn.css";
import "@/components/ctn/reports/reports.css";

export default function CtnReports() {
  const { data: metadata, error: metadataError } = useCtnMetadata();
  const [filters, setFilters] = useState({ ...emptyFilters }), [expanded, setExpanded] = useState(false);
  const [data, setData] = useState(null), [loading, setLoading] = useState(true), [error, setError] = useState("");
  const [exporting, setExporting] = useState(false), [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController(); setLoading(true); setError("");
    const timer = setTimeout(async () => {
      try { const response = await axios.get(`${API}/rapporten`, { params: filters, signal: controller.signal, timeout: 30000 }); if (!controller.signal.aborted) setData(response.data); }
      catch (e) { if (!controller.signal.aborted) { setData(null); setError(errorText(e)); } }
      finally { if (!controller.signal.aborted) setLoading(false); }
    }, 250);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [filters, retry]);
  const download = async () => { setExporting(true); try { await downloadCtn("export/excel", "ctn_rapportgegevens.xlsx", filters); } catch (e) { toast.error(errorText(e)); } finally { setExporting(false); } };
  return <div className="ctn-module ctn-reports" data-testid="ctn-reports-page">
    <CtnHeader title="Rapporten & analyse"><CtnReportToolbar filters={filters} setFilters={setFilters} expanded={expanded} setExpanded={setExpanded} exporting={exporting} onExport={download} disabled={loading || !!error || !data} /></CtnHeader>
    {expanded && <CtnReportExtraFilters filters={filters} setFilters={setFilters} metadata={metadata} />}
    <CtnError error={error || metadataError} retry={() => setRetry((value) => value + 1)} />
    {loading ? <div className="ctn-report-loading" role="status" data-testid="ctn-reports-loading">Rapport laden…</div> : data && !error && <>
      <CtnReportStats data={data} />
      {data.bestellingen === 0 ? <CtnEmpty title="Geen bestellingen in deze selectie" /> : <div className="ctn-report-sections">
        <CtnSupplierChart rows={data.per_leverancier} filters={filters} />
        <CtnDistributionChart id="categorie" title="Verdeling per categorie" label="Categorie" rows={data.per_categorie} filters={filters} />
        <CtnDistributionChart id="kleur" title="Topkleuren" label="Kleur" rows={data.per_kleur} filters={filters} />
        <CtnReportSection id="bestemming" title="Stuks per bestemming" label="Bestemming" rows={data.per_bestemming} filters={filters}><CtnReportLegend rows={data.per_bestemming} id="bestemming" total={data.stuks} singleColor /></CtnReportSection>
      </div>}
    </>}
  </div>;
}